import entitiesService from "@/services/entitiesService";

var CryptoJS = require("crypto-js");
var CryptoJSAesJson = {
  stringify: function(cipherParams) {
    var j = { ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64) };
    if (cipherParams.iv) j.iv = cipherParams.iv.toString();
    if (cipherParams.salt) j.s = cipherParams.salt.toString();
    return JSON.stringify(j);
  },
  parse: function(jsonStr) {
    var j = JSON.parse(jsonStr);
    var cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(j.ct),
    });
    if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv);
    if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s);
    return cipherParams;
  },
};

export const state = {
  userEntities: [],
  pendingInvitation: {},
  totalRows: 0,
  perPage: 0
};

export const actions = {
  fetchUserEntities({ commit }, params) {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      entitiesService
        .getUserEntities(params)
        .then((data) => {
          resolve(data);
          commit("setTotalRows", data.data.total);
          commit("setPerPage", data.data.per_page);
          const key = localStorage.getItem("serverId");
          const userId = JSON.parse(localStorage.getItem("user")).data.user.id;
          let encryptedUserId = CryptoJS.AES.encrypt(
            JSON.stringify(userId),
            key,
            { format: CryptoJSAesJson }
          ).toString();
          data.data.data.forEach(element => {
            element.userId = btoa(encryptedUserId);
          });
          commit("setUserEntities", data.data.data);
          commit("setLoading", false);
        })
        .catch((err) => {
          reject(err);
          commit("setLoading", false);
        });
    });
  },
  fetchAllUserEntities({ commit }) {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      entitiesService
        .getAllUserEntities()
        .then((data) => {
          resolve(data);
          console.log('fetchAllUserEntities', data);
          commit("setLoading", false);
        })
        .catch((err) => {
          reject(err);
          // commit("setLoading", false);
        });
    });
  },
  getUserProfile({ commit }) {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      entitiesService
        .getUserProfile()
        .then((data) => {
          resolve(data);
          commit("setLoading", false);
        })
        .catch((err) => {
          reject(err);
          // commit("setLoading", false);
        });
    });
  },
  savePendingInvitation({ commit }, params) {
    commit("setPendingInvitation", params);
  },
  clearStoredPendingInvitation({ commit }) {
    commit("setPendingInvitation", {});
  },
};

export const mutations = {
  setLoading(state, payload) {
    state.loading = payload;
  },
  setUserEntities(state, payload) {
    state.userEntities = payload;
  },
  setPendingInvitation(state, payload) {
    state.pendingInvitation = payload;
  },
  setTotalRows(state, payload) {
    state.totalRows = payload;
  },
  setPerPage(state, payload) {
    state.perPage = payload;
  },
};

export const getters = {
  getLoading(state) {
    return state.loading;
  },
  getUserEntities(state) {
    return state.userEntities;
  },
  getPendingInvitation(state) {
    return state.pendingInvitation;
  },
  getTotalRows(state) {
    return state.totalRows;
  },
  getPerPage(state) {
    return state.perPage;
  },
};
